module.exports = __webpack_public_path__ + "6ba0d34c7e4b730b9b47dbee1fc56132.jpg";